<ppl-signed-out
  [message]="message"
  (signIn)="onSignIn()"></ppl-signed-out>
